declare global {
  interface Window {
    dataLayer: any[]
  }
}

interface TrackingEvent {
  type: 'elysiumEvent' | 'customEvent' | 'marketing_preference'
  eventData: {
    eventAction: string
    eventCategory: string
    eventLabel?: string
    eventLabelValue?: string
    eventPage?: string
  }
}

export interface EnhancedTrackingEvent {
  event: string
}

export const pushToDataLayer = (event: TrackingEvent) => {
  if (!window) {
    return
  }
  if (!window.dataLayer) {
    window.dataLayer = []
  }

  window.dataLayer.push({
    event: event.type,
    eventData: {
      ...event.eventData,
      eventPage: window.location.pathname,
    },
  })
}

export const pushToEnhancedDataLayer = <T extends EnhancedTrackingEvent>(
  event: T,
) => {
  if (!window) {
    return
  }

  if (!window.dataLayer) {
    window.dataLayer = []
  }

  window.dataLayer.push(event)
}
